let depth = 0;
const listeners = new Set();

function notify() {
  listeners.forEach((listener) => {
    try {
      listener(depth);
    } catch {
      /* ignore */
    }
  });
}

export function getPortalLoadingDepth() {
  return depth;
}

export function portalLoadingStart() {
  depth += 1;
  notify();
}

export function portalLoadingEnd() {
  depth = Math.max(0, depth - 1);
  notify();
}

export function subscribePortalLoading(listener) {
  listeners.add(listener);
  listener(depth);
  return () => listeners.delete(listener);
}
